
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import Qrcode from '@xt/www/components/showQrcode/index.vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'

@Component({
  components: {
    Qrcode,
    LazyImg
  }
})
export default class extends Vue {
  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
